export const ColumnType = {
  numeric: 'numeric',
  string: 'string',
  date: 'date',
  jsx: 'jsx',
  boolean: 'boolean',
};

export const Order = {
  asc: 'asc',
  desc: 'desc'
};

export const SortHiddenType = [ColumnType.jsx];

export const SortBy = { key: '', type: ColumnType.string, order: Order.desc };

export const isHiddenSort = ({ type, hideSort = false }) => {
  if (hideSort) return hideSort;
  const isHidden = SortHiddenType.includes(type);
  return isHidden;
};

export const sortedTextArray = (rows = [''], order = Order.asc) => {
  return rows.sort((a, b) => {
    return order === Order.asc
      ? a.localeCompare(b)
      : b.localeCompare(a);
  });
};

export const sort = (rows = [], key = '', order = '', type = '') => {
  switch(type) {
    case ColumnType.string: {
      return rows.sort((a, b) => {
        const x = a[key] || '';
        const y = b[key] || '';
        return order === Order.asc
          ? x.localeCompare(y)
          : y.localeCompare(x);
      });
    }
    case ColumnType.numeric: {
      return rows.sort((a, b) => {
        const x = a[key] || 0;
        const y = b[key] || 0;
        return order === Order.asc
          ? x - y
          : y - x;
      });
    }
    case ColumnType.date: {
      const _sortableRows = [];
      const _unsortableRows = [];

      rows.forEach((r) => {
        const t = new Date(r[key]).getTime();

        if (isNaN(t)) {
          _unsortableRows.push(r);
          return {};
        }

        _sortableRows.push(r);
      });

      const _sortedRows = _sortableRows.sort((a, b) => {
        const x = new Date(a[key]).getTime();
        const y = new Date(b[key]).getTime();

        return order === Order.asc
          ? x - y
          : y - x;
      });

      return [..._sortedRows, ..._unsortableRows];
    }
    default:
      return rows;
  }
};
